const preferenceHash = '#shopifyReshowConsentBanner';

const isPreferenceLink = (link) => {
  if (!(link instanceof HTMLAnchorElement)) return false;

  try {
    return new URL(link.href, window.location.href).hash === preferenceHash;
  } catch {
    return false;
  }
};

const normalizePreferenceLink = (link) => {
  if (isPreferenceLink(link)) link.href = preferenceHash;
};

document.querySelectorAll(`a[href*="${preferenceHash}"]`).forEach(normalizePreferenceLink);

document.addEventListener('click', (event) => {
  const link = event.target instanceof Element
    ? event.target.closest(`a[href*="${preferenceHash}"]`)
    : null;
  if (!isPreferenceLink(link)) return;

  normalizePreferenceLink(link);
  const showPreferences = window.privacyBanner?.showPreferences;
  if (typeof showPreferences !== 'function') return;

  event.preventDefault();
  Promise.resolve(showPreferences.call(window.privacyBanner)).catch((error) => {
    console.error('Shopify cookie preferences could not be opened.', error);
    window.location.hash = preferenceHash;
  });
});
